var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m512 591 314-314q21-21 51.5-21t51.5 21q22 22 22 52t-22 52L564 747q-21 21-51.5 21T461 747L95 381q-22-22-22-52t22-52q21-21 51.5-21t51.5 21l314 314z"
  })));
};
export { SvgChevronDown as ReactComponent };
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSAiZGF0YTppbWFnZS9zdmcreG1sO2Jhc2U2NCxQSE4yWnlCMmFXVjNRbTk0UFNJd0lEQWdNVEF5TkNBeE1ESTBJaUI0Yld4dWN6MGlhSFIwY0RvdkwzZDNkeTUzTXk1dmNtY3ZNakF3TUM5emRtY2lQanh3WVhSb0lHUTlJazAxTVRJZ05Ua3hiRE14TkMwek1UUnhNakV0TWpFZ05URXVOUzB5TVhRMU1TNDFJREl4Y1RJeUlESXlJREl5SURVeWRDMHlNaUExTWt3MU5qUWdOelEzY1MweU1TQXlNUzAxTVM0MUlESXhWRFEyTVNBM05EZE1PVFVnTXpneGNTMHlNaTB5TWkweU1pMDFNblF5TWkwMU1uRXlNUzB5TVNBMU1TNDFMVEl4ZERVeExqVWdNakZzTXpFMElETXhOSG9pTHo0OEwzTjJaejQ9Ig==";